export { DeviceThemeProvider } from './DeviceDetection';
